export type NetworkError = {
  error: boolean;
};

export function hasErrorField<T>(
  target: T | NetworkError,
): target is NetworkError {
  return target && target['error'] !== undefined;
}
